// extracted by mini-css-extract-plugin
var _1 = "wrapper-vLey9";
export { _1 as "wrapper" }
